<template>
    <div id="pay_success">
        <div class="top_title fixed">上架成功</div>
        <div class="success">
            <p>上架成功，可前往正在出售</p>
            <p>管理商品</p>
        </div>
        <van-button class="backMarket first" color="var(--theme)" type="primary" @click="backmarket">正在出售</van-button>
        <van-button plain color="var(--theme)" class="backMarket" @click="gotobag">继续上架</van-button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        backmarket() {
            this.$store.commit('setPack','ing')
            this.$router.push({
                name: 'sell'
            })
        },
        gotobag() {
            this.$store.commit('setPack', 'pack')
            this.$router.push({
                name: 'sell'
            })
        }
    },
}
</script>
<style lang="less" scoped>
    #pay_success {
        .success {
            margin: 8.8rem 0 21.2rem;
            p {
                text-align: center;
                font-size: 1.45rem;
                color: #999;
            }
        }
        .backMarket {
            display: block;
            margin: 0 auto;
            width: 13.5rem;
            height: 3.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 10rem;
            font-size: 1.4rem;
        }
    }
    .first {
        margin-bottom: 1.5rem !important;
    }
</style>